
export enum SyncStrategy {
	Mobile = 'mobile',
	Online = 'online',
}
